import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import customerSalesRoutes from './customer-sales/routes';
import fastMovingRoutes from './fast-moving/routes';
import salesReportsRoutes from './sales-reports/routes';

const WarehouseDashboard = lazy(() => import('./pages/WarehouseDashboard'));
const LoyaltyOverview = lazy(() => import('./loyalty/pages/LoyaltyOverview'));
const LoyaltyCustomersList = lazy(() => import('./loyalty/pages/LoyaltyCustomersList'));
const CustomerTransactions = lazy(() => import('./loyalty/pages/CustomerTransactions'));
const ReorderReport = lazy(() => import('./reorder/pages/ReorderReport'));
const ReorderSettings = lazy(() => import('./reorder/pages/ReorderSettings'));
const ArrivalsDetailsReport = lazy(() => import('./reorder/pages/ArrivalsDetailsReport'));
const ReorderOrderList = lazy(() => import('./reorder/pages/ReorderOrderList'));
const MISOverviewPage = lazy(() => import('./mis-reports/pages/MISOverviewPage'));
const SeasonalPatternsPage = lazy(() => import('./mis-reports/pages/SeasonalPatternsPage'));
const SalesTrendsPage = lazy(() => import('./mis-reports/pages/SalesTrendsPage'));
const DemandForecastPage = lazy(() => import('./mis-reports/pages/DemandForecastPage'));
const PlanningSummaryPage = lazy(() => import('./mis-reports/pages/PlanningSummaryPage'));

const warehouseRoutes: RouteObject[] = [
  {
    index: true,
    element: <WarehouseDashboard />,
  },
  {
    path: 'loyalty-overview',
    element: <LoyaltyOverview />,
  },
  {
    path: 'loyalty-customers',
    element: <LoyaltyCustomersList />,
  },
  {
    path: 'loyalty-customers/:customerId',
    element: <CustomerTransactions />,
  },
  {
    path: 'reorder',
    element: <ReorderReport />,
  },
  {
    path: 'reorder/settings',
    element: <ReorderSettings />,
  },
  {
    path: 'reorder/arrivals',
    element: <ArrivalsDetailsReport />,
  },
  {
    path: 'reorder/item-reorder-list',
    element: <ReorderOrderList />,
  },
  {
    path: 'mis-reports',
    element: <MISOverviewPage />,
  },
  {
    path: 'mis-reports/seasonal',
    element: <SeasonalPatternsPage />,
  },
  {
    path: 'mis-reports/sales-trends',
    element: <SalesTrendsPage />,
  },
  {
    path: 'mis-reports/demand-forecast',
    element: <DemandForecastPage />,
  },
  {
    path: 'mis-reports/planning',
    element: <PlanningSummaryPage />,
  },
  ...customerSalesRoutes,
  ...fastMovingRoutes,
  ...salesReportsRoutes,
];

export default warehouseRoutes;
